import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  pageContentWrapper: {
    margin: '0 auto',
    padding: '0 7.3rem',
    maxWidth: '109.6rem',
  },
  pageHeader: {
    textAlign: 'center',
    margin: '5.6rem auto',
    maxWidth: '109.6rem',
  },
  title: {
    font: {
      size: '3.4rem',
      lineHeight: '4rem',
    },
    marginBottom: '0.8rem',
  },
  subtitle: {
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 500,
    },
    margin: '0',
    color: colors.neutral[700],
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
